import React from 'react';
import CustomButton from './CustomButton';
import './theme.css';

export default class Bookmarkemoji extends React.Component {
  constructor(props)
  {
    super(props);
    this.handleBookmarkChange = this.handleBookmarkChange.bind(this);
    this.handleEmojiChange = this.handleEmojiChange.bind(this);

    this.state = {bookmark:'¯\\_(ツ)_/¯', emoji:'¯\\_(ツ)_/¯'};

  }

  handleBookmarkChange(event) {
    this.setState({bookmark: event.target.value});
  }

  handleEmojiChange(event) {
    this.setState({emoji: event.target.value});
  }

  render() {
    let jsbookmark = `javascript: var c = document.activeElement;var v = document.createElement('textarea');v.innerHTML = '` + this.state.emoji + `';document.body.appendChild(v);v.select();document.execCommand('copy');v.remove();c.focus();`;
    return (
        <div className="keret ablak">
            <h1><i className="material-icons">bookmark_border</i> Bookmark emoji generator</h1>
            <p>Bookmark name:</p>
            <input id='name' type="text" value={this.state.bookmark} onChange={this.handleBookmarkChange}></input>
            <p>Emoji:</p>
            <input id='emoji' type="text" value={this.state.emoji} onChange={this.handleEmojiChange}></input>
          <div>
            <p>Result:</p>
            {/*style={{cursor: 'move'}}*/}
            <CustomButton big text={this.state.bookmark} newTab url={jsbookmark} tooltip="Drag&drop this to your bookmark bar"/>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/Bookmarkemoji.js